/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { ApiMenu } from './ApiMenu'
import { ApiMenuFromJSON, ApiMenuFromJSONTyped, ApiMenuToJSON } from './ApiMenu'

/**
 *
 * @export
 * @interface EnvelopedApiMenuApiMenuAdmin
 */
export interface EnvelopedApiMenuApiMenuAdmin {
  /**
   *
   * @type {ApiMenu}
   * @memberof EnvelopedApiMenuApiMenuAdmin
   */
  body: ApiMenu
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedApiMenuApiMenuAdmin
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedApiMenuApiMenuAdmin interface.
 */
export function instanceOfEnvelopedApiMenuApiMenuAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedApiMenuApiMenuAdminFromJSON(json: any): EnvelopedApiMenuApiMenuAdmin {
  return EnvelopedApiMenuApiMenuAdminFromJSONTyped(json, false)
}

export function EnvelopedApiMenuApiMenuAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedApiMenuApiMenuAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: ApiMenuFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedApiMenuApiMenuAdminToJSON(
  value?: EnvelopedApiMenuApiMenuAdmin | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: ApiMenuToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
